import { assertNever } from "@redotech/util/type";
import classNames from "classnames";
import { JSXElementConstructor, memo } from "react";
import { UserImage, UserImageSize } from "../../user-image";
import {
  FeaturedIconSize,
  RedoFeaturedIcon,
  RedoFeaturedIconProps,
} from "../featured-icon/redo-featured-icon";
import * as redoListItemCss from "./redo-list-item.module.css";
import {
  RedoListItemSize,
  itemSizeToSizeClass,
} from "./standard-redo-list-items";

// type PresenceStatus = "active" | "busy" | "offline" | "away";
// interface PresenceDot {
//   type: "presence";
//   status: PresenceStatus;
// }

interface Icon {
  type: "icon";
  Icon: JSXElementConstructor<any>;
}

interface FeaturedIcon {
  type: "featured";
  iconProps: Omit<RedoFeaturedIconProps, "size">;
}

interface Avatar {
  type: "avatar";
  imageUrl: string | null | undefined;
  alt: string;
  name: string | undefined;
}

const statusDotColor = [
  "green",
  "yellow",
  "red",
  "gray",
  "transparent",
] as const;
export type StatusDotColor = (typeof statusDotColor)[number];

interface StatusDot {
  type: "status";
  color: StatusDotColor;
}

export type LeadingItem = Icon | Avatar | FeaturedIcon | StatusDot;

export const RedoListItemLeadingItem = memo(function RedoListItemLeadingItem({
  leadingItem,
  size,
}: {
  leadingItem: LeadingItem;
  size: RedoListItemSize;
}) {
  switch (leadingItem.type) {
    case "icon":
      return (
        <leadingItem.Icon
          className={classNames(
            redoListItemCss.icon,
            itemSizeToSizeClass[size],
          )}
        />
      );
    case "avatar":
      return <UserImage {...leadingItem} size={avatarSize[size]} />;
    case "featured":
      return (
        <RedoFeaturedIcon
          {...leadingItem.iconProps}
          size={listItemSizeToFeaturedIconSize[size]}
        />
      );
    case "status":
      return (
        <span
          className={classNames(
            redoListItemCss.statusDotContainer,
            itemSizeToSizeClass[size],
          )}
        >
          <span
            className={classNames(
              redoListItemCss.statusDot,
              statusDotColorToClass[leadingItem.color],
              itemSizeToSizeClass[size],
            )}
          />
        </span>
      );
    default:
      assertNever(leadingItem);
  }
});

const statusDotColorToClass: Record<StatusDotColor, string> = {
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  green: redoListItemCss.green,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  yellow: redoListItemCss.yellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  red: redoListItemCss.red,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  gray: redoListItemCss.gray,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  transparent: redoListItemCss.transparent,
};

const avatarSize: Record<RedoListItemSize, UserImageSize> = {
  xs: UserImageSize.X_TINY,
  sm: UserImageSize.TINY,
  md: UserImageSize.MICRO,
  lg: UserImageSize.MICRO,
};

const listItemSizeToFeaturedIconSize: Record<
  RedoListItemSize,
  FeaturedIconSize
> = { xs: "xxs", sm: "xxs", md: "xs", lg: "sm" };
